/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { token } from '@atlaskit/tokens';

import { baseColumnStyles } from '../common.styled';
import { profileGridSizeTimes } from '../constants';

/**
 * A narrow column that does not grow or shrink in width except on narrow
 * screens where it fills the available width.
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AsideColumn = styled.aside`
	${baseColumnStyles};
	flex: 0 0 ${profileGridSizeTimes(4)}px;
	margin-bottom: ${token('space.400', '32px')};

	&:last-of-type {
		margin-bottom: 0;
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AsideColumnItem = styled.div`
	&:not(:last-child) {
		margin-bottom: ${token('space.300', '24px')};
	}
`;
